import React from 'react';

export const LINK_EXPIRED_STEP = 'link_expired';

// Older API builds send only message: 'Expired token'.
export const isLinkTokenExpired = (error) => {
  const data = error?.response?.data;
  return (
    data?.error === 'link_token_expired' || data?.message === 'Expired token'
  );
};

const LinkExpired = ({ onClose }) => (
  <div className="cobalt-flex cobalt-flex-col cobalt-items-center cobalt-justify-center cobalt-h-2/3">
    <h1 className="cobalt-embedded-h1 cobalt-w-5/6 cobalt-mb-4">
      This session has expired.
    </h1>
    <div className="cobalt-w-5/6">
      <p className="cobalt-embedded-p">
        For your security, this session expires after 30 minutes. Please close
        this window and start again to connect your account.
      </p>
    </div>
    {onClose && (
      <div className="cobalt-mt-4">
        <button
          onClick={onClose}
          className="cobalt-p-2 cobalt-bg-blue-500 cobalt-text-white cobalt-rounded hover:cobalt-bg-blue-700 cobalt-transition-colors cobalt-duration-200"
        >
          Close
        </button>
      </div>
    )}
  </div>
);

export default LinkExpired;
